module.exports = __webpack_public_path__ + "img/style1.303129f3.png";